import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div className="dashboard-home">
      <header className="welcome-banner">
        <h1>Welcome to Your Dashboard</h1>
        <p>
          This space is built for <strong>Coordinators</strong>, <strong>Admins</strong>, 
          and <strong>Moderators</strong>. Here’s everything you need to know to get started.
        </p>
      </header>

      <section className="quick-start">
        <h2 >🚀 Quick Start Guide</h2>
        <ol>
          <li>Use the sidebar to navigate between sections.</li>
          <li>Check your emails regularly for important updates.</li>
          <li>Manage submissions, users, and discussions based on your role.</li>
          <li>Always log out when finished to keep the system secure.</li>
        </ol>
      </section>

      <section className="role-overview">
        <h2 >👥 Roles & Responsibilities</h2>
        <div className="roles-grid">
          <div className="role-box coordinator">
            <h3>Coordinator</h3>
            <p>Assign tasks, manage submissions, and support students efficiently.</p>
          </div>
          <div className="role-box admin">
            <h3>Admin</h3>
            <p>Control system settings, manage user accounts, and oversee operations.</p>
          </div>
          <div className="role-box moderator">
            <h3>Moderator</h3>
            <p>Ensure content quality, monitor discussions, and maintain community rules.</p>
          </div>
        </div>
      </section>

      <footer className="dashboard-footer">
        <p>💡 Tip: Explore the dashboard menu to discover all available tools.</p>
      </footer>
    </div>
  );
};

export default Home;
